import React, { Suspense, useState, useEffect } from 'react';
import { raygun } from '@ynap/clientside-monitoring';

const Lottie = React.lazy(() => import(/* webpackChunkName: "Lottie" */ 'lottie-react'));

const animations = {
    nap: {
        stroke: './jsonAnimations/LoadingWishlistIcon.nap.json',
        filledMask: './jsonAnimations/FilledMaskWishlistIcon.nap.json',
    },
    theoutnet: {
        stroke: './jsonAnimations/LoadingWishlistIcon.json',
        filledMask: './jsonAnimations/FilledMaskWishlistIcon.json',
    },
    mrp: {
        stroke: './jsonAnimations/LoadingWishlistIcon.mrp.json',
        filledMask: './jsonAnimations/FilledMaskWishlistIcon.mrp.json',
    },
};

const IconAnimated = (props) => {
    const { brand, fallbackIcon = '', icon, loop } = props;
    const [animationData, setAnimationData] = useState(null);

    useEffect(() => {
        if (animations[brand][icon]) {
            import(
                /* webpackExclude: /\__tests__$/ */
                /* webpackChunkName: "lottie-animation-file" */
                `${animations[brand][icon]}`
            )
                .then((data) => {
                    // convert anonymous object
                    const animationData = { ...data };
                    setAnimationData(animationData);
                })
                .catch((error) => {
                    raygun.helpers.agent('send', {
                        error,
                        tags: ['lottieAnimation'],
                    });
                });
        }
    }, [icon]);

    return (
        <Suspense fallback={fallbackIcon}>
            <Lottie {...props} animationData={animationData} loop={loop} />
        </Suspense>
    );
};

export default IconAnimated;
